import { Injectable, forwardRef, inject } from '@angular/core';
import { RxStomp, RxStompConfig } from '@stomp/rx-stomp';
import { catchError, filter, firstValueFrom, switchMap, take, tap } from 'rxjs';

import { DmbEnvironment } from '../../dmb-environment';
import { CommsAuthService } from './comms-auth.service';

@Injectable({ providedIn: 'root', useClass: forwardRef(() => DmbRxStompConfig) })
export abstract class StompConfig extends RxStompConfig {}

@Injectable({ providedIn: 'root' })
export class DmbRxStompConfig extends StompConfig {
  private authService = inject(CommsAuthService);

  constructor() {
    super();

    const v5 = inject(DmbEnvironment).v5Path(true);

    this.webSocketFactory = () => {
      return new WebSocket(`${v5}/dmbsock`);
    };
    this.connectionTimeout = 0;

    this.reconnectDelay = 2000;
    this.heartbeatOutgoing = 30000;
    this.heartbeatIncoming = 10000;

    // this.debug = (msg): void => {
    //   console.log(new Date(), msg);
    // };

    this.beforeConnect = async (client: RxStomp) => {
      await firstValueFrom(
        this.authService.authenticated.pipe(
          filter((v) => v),
          switchMap(() => this.authService.token),
          catchError(() => 'Rx stomp connect catch error has been called'),
          tap((token) => (client.stompClient.connectHeaders['X-XSRF-TOKEN'] = token)),
          take(1),
        ),
      );
    };
  }
}
